import React from 'react';

import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

const AppMagnittLoader = ({ data = {} }) => {
    const height = data.height || 'auto';
    const background = data.background || '#FFF';
    const padding = data.padding || '100px 150px';

    return (
        <div
            style={{ backgroundColor: background, height, padding }}
            className="row spinner spin"
        >
            <div>
                <img
                    className="spinnerLogo"
                    src={`${PUBLIC_IMG_URL}/logo_loader.png`}
                    style={{ margin: 'auto' }}
                    alt="Magnitt-Loading-Image"
                />
                <span className="spinnerDot"></span>
                <span className="spinnerDot spinnerDot2"></span>
                <span className="spinnerDot spinnerDot3"></span>
                <h5 className="red mt-3">Loading...</h5>
            </div>
        </div>
    );
};

export default AppMagnittLoader;
